import React, {useEffect, useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPaperPlane, faHeart, faComment } from "@fortawesome/free-solid-svg-icons";
import * as ForumApi from "../../api/apiForum";
import { Timestamp } from "firebase/firestore";
import { useSelector } from "react-redux";




/**
 * ForoItemProps interface
 */
interface ForoItemProps {
  foro: any; //foro a mostrar
  onclick: Function; //función que se ejecuta al dar click
}

type msgForo = {
  id: string,
  autor: string,
  comentario: string,
  date: Timestamp,
}


/**
 * ForoItem component
 * @param {any} foro - foro a mostrar
 * @param {Function} onclick - función que se ejecuta al dar click
 * @param {string} userID - id del usuario
 * @return {JSX.Element} - ForoItem component
 */
const ForoItem = ({ foro, onclick, userID }) => {
  const [userMsg, setUserMsg] = useState("");
  const user = useSelector((state: any) => state.user.userData );
  const [liked, setLiked] = useState(false);
  const [showingComments, setShowingComments] = useState(false);
  const [msgForo, setMsgForo] = useState<Array<msgForo>>([]);
  const [loading, setLoading] = useState(false);

  async function getMsgForo(id) {
    let MSG = await ForumApi.getComments(id);
    if (MSG) {
        MSG = MSG.sort((a, b) => {
            return a.date - b.date;
        });
    }
    setMsgForo(MSG);
  }

  const handleCreateMsg = async() => {
    if (userMsg.length > 0) {
        setLoading(true);
        let result = await ForumApi.createComments(foro.id, userMsg, user.name, user.uid);
        setLoading(false);
        if (result) {
            setUserMsg("");
            getMsgForo(foro.id);
        }
    }
}

  useEffect(() => {
    setMsgForo([]);
    if (foro.id !== null) {
        getMsgForo(foro.id); // 
    }
}, [foro]);

  return (
    <>
    <section 
    className="foro-item shadow"
      style={{
        padding: "0px",
        margin: "30px",
        textAlign: "center",
        backgroundColor: "rgba(232, 222, 201, 0.5)",
        borderRadius: "10px",
      }}
    ><div style={{backgroundColor: "white", padding: "10px", borderRadius: "10px"}}>
      <div style={{textAlign: "left", display: "flex", justifyContent: "space-between"}}>
        <h3 style={{margin: 0}}>{foro.title}</h3>
        <p style={{margin: 0}}>{foro.created}</p>
      </div>
      <p style={{margin: 0}}>{foro.description}</p>

      <div>
        <button 
          onClick={() => {
            if (userID === "") return;
            ForumApi.giveLikeToForum(userID, foro.id);
            setLiked(!liked);
            foro.likes += liked ? -1 : 1;
          }}
          style={{
            margin: 5,
            border: "none",
            backgroundColor: "transparent",
        }}><FontAwesomeIcon icon={faHeart} size="2x" color={userID === "" ? "gray" : liked ? "red" : "black"} /></button>
        <span>{foro.likes}</span>
        <button onClick={() => {
          setShowingComments(!showingComments)
          onclick();
          }}
          style={{
            margin: 5,
            border: "none",
            backgroundColor: "transparent",
        }}><FontAwesomeIcon icon={faComment} size="2x" /></button>
        <span>{foro.comments}</span>
      </div>
      <div style={{width: "90%", margin:"auto"}}>
        {showingComments && 
        <>
        <div style={{display: "flex",
        justifyContent: "left",
        flexDirection: "column",
        alignContent: "start"
        }}>
          <div style={{width: "100%", height: "1px", backgroundColor: "grey", borderRadius: "1px", marginBottom: "10px"}}></div>
          {msgForo.map(msg => <div style={{backgroundColor: "rgba(0, 0, 201, 0)", textAlign: "left", display: "flex", flexDirection: "row", alignItems: "center"
        }}><p>{msg.autor+" ("+msg.date.toDate().toLocaleDateString()+"): "}</p> {msg.comentario}</div>)}
        </div>
          {user !== null && <div className="foro-send_msg">
          <form onSubmit={(e) => {
              e.preventDefault();
              handleCreateMsg();
          }
          }>
              <label htmlFor="msg">Mensaje:</label>
              <input type="text" id="msg" required autoComplete="off" value={userMsg} onChange={(e) => setUserMsg(e.target.value)} />
              <button type="submit" disabled={loading}>
                  <FontAwesomeIcon 
                      icon={faPaperPlane}
                      size="2x"
                      style={{
                          color: "black",
                      }}
                  />
              </button>
          </form>
      </div>}
      </>
        }
      </div>
      

    </div>
    </section>
    </>
  );
};

export default ForoItem;